<template>
  <div class="sbm-root" :class="`sbm--${side}`" :style="rootStyle">
    <div class="sbm-toggle" :class="{ 'sbm-toggle--right': side === 'right' }">
      <v-btn icon small @click="expanded = !expanded">
        <v-icon small>{{ toggleIcon }}</v-icon>
      </v-btn>
    </div>
    <!-- Rendered OUTSIDE the v-show below: this is the slot for things that must
         survive collapsing, like page navigation. It receives `expanded` so the
         consumer can drop to icons only. -->
    <div class="sbm-nav">
      <slot name="nav" :expanded="expanded" />
    </div>
    <div v-show="expanded" class="sbm-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBarMenu',
  props: {
    width:           { type: String, default: '300px' },
    collapsedWidth:  { type: String, default: '40px' },
    initialExpanded: { type: Boolean, default: false },
    side:            { type: String, default: 'left' }, // 'left' | 'right'
  },
  data() {
    return { expanded: this.initialExpanded }
  },
  computed: {
    rootStyle() {
      return { width: this.expanded ? this.width : this.collapsedWidth }
    },
    toggleIcon() {
      if (this.side === 'right') return this.expanded ? 'mdi-chevron-right' : 'mdi-chevron-left'
      return this.expanded ? 'mdi-chevron-left' : 'mdi-menu'
    },
  },
}
</script>

<style scoped>
.sbm-root {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  min-height: 0;

  background-color: #15171c;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  transition: width 0.25s ease;
  overflow: hidden;
  flex-shrink: 0;
}

.sbm--right {
  border-right: none;
  border-left: 1px solid rgba(255, 255, 255, 0.08);
}

.sbm-toggle {
  display: flex;
  align-items: center;
  padding: 6px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.sbm-toggle--right {
  justify-content: flex-end;
}

.sbm-nav {
  flex-shrink: 0;
}

.sbm-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
